import React from "react";
import "./overview.css";
import { useSelector } from "react-redux";
import { CiMail } from "react-icons/ci";
import { BsTelephone, BsCalendar2Event } from "react-icons/bs";
import { FaBirthdayCake } from "react-icons/fa";
import { ImLocation2, ImFlag } from "react-icons/im";
import { GrStatusUnknown } from "react-icons/gr";
import moment from "moment";
import { capitalize } from "../../../../core/utils/helpers";

const Overview = () => {
  const team_member_infos = useSelector(
    (state) => state.setInitConf.currentTeamMemberData,
  );

  return (
    <div className="u-d-overview">
      <h1>Contact information</h1>
      <div className="overview-wrapper">
        <div className="ow-row">
          <BsCalendar2Event className="icon" />
          <div className="ow-col">
            <h3>Created on</h3>
            <span>{moment(team_member_infos?.created_at).format("LLLL")}</span>
          </div>
        </div>
        <div className="ow-row">
          <BsTelephone className="icon" />
          <div className="ow-col">
            <h3>Telephone</h3>
            <span>{team_member_infos?.telephone || "---"}</span>
          </div>
        </div>
        <div className="ow-row">
          <CiMail className="icon" />
          <div className="ow-col">
            <h3>Email</h3>
            <span>{team_member_infos?.mail}</span>
          </div>
        </div>
        <div className="ow-row">
          <FaBirthdayCake className="icon" />
          <div className="ow-col">
            <h3>Date of Birth</h3>
            <span>{moment(team_member_infos?.date_of_birth).format("LL")}</span>
          </div>
        </div>
        <div className="ow-row">
          <ImLocation2 className="icon" />
          <div className="ow-col">
            <h3>Location of Birth</h3>
            <span>{team_member_infos?.location_of_birth}</span>
          </div>
        </div>
        <div className="ow-row">
          <ImFlag className="icon" />
          <div className="ow-col">
            <h3>Country of Origin</h3>
            <span>{team_member_infos?.origin_country}</span>
          </div>
        </div>
        <div className="ow-row">
          <GrStatusUnknown className="icon" />
          <div className="ow-col">
            <h3>Profession</h3>
            <span>{capitalize(team_member_infos?.profession)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
